import React from 'react';
import { Container, Row, Col, Form, Table } from 'react-bootstrap';
import Skeleton from 'src/Admin/components/common/skeleton';
const EnrollmentRulesSkeleton = () => {
  return (
    <Container fluid className="enrollmentrules">
      <Form className="border-right-after">
        <Row className="Payment-details">
          <Col md={4} lg={4} sm={4} className="padding-0">
            <Skeleton width={250} height={50} count={1} />
          </Col>
          <Col md={4} lg={4} sm={4} className="padding-0">
            <div>
              <Table striped bordered hover className="m-0">
                <Skeleton width={450} height={240} count={1} />
              </Table>
            </div>
          </Col>
        </Row>
        <Row className="Payment-details pb-0">
          <Col md={4} lg={4} sm={4} className="padding-0">
            <Skeleton width={250} height={50} count={1} />
          </Col>
          <Col md={8} lg={8} sm={8} className="setup-form">
            <Row className="pt-2">
              <Col sm={4} md={4} lg={4}>
                <Skeleton width={150} height={40} count={1} />
              </Col>
              <Col sm={4} md={4} lg={4}>
                <Skeleton width={150} height={40} count={1} />
              </Col>
              <Col sm={4} md={4} lg={4}>
                <Skeleton width={150} height={40} count={1} />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="Payment-details pb-0">
          <Col md={4} lg={4} sm={4} className="padding-0"></Col>
          <Col md={8} lg={8} sm={8} className="setup-form">
            <Row className="pt-2">
              <Col sm={4} md={4} lg={4}>
                <Skeleton width={150} height={40} count={1} />
              </Col>
              <Col sm={4} md={4} lg={4}>
                <Skeleton width={150} height={40} count={1} />
              </Col>
              <Col sm={4} md={4} lg={4}>
                <Skeleton width={150} height={40} count={1} />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="Payment-details pb-0">
          <Col md={4} lg={4} sm={4} className="padding-0"></Col>
          <Col md={8} lg={8} sm={8} className="setup-form">
            <Row className="pt-2">
              <Col sm={4} md={4} lg={4}>
                <Skeleton width={150} height={40} count={1} />
              </Col>
              <Col sm={4} md={4} lg={4}>
                <Skeleton width={150} height={40} count={1} />
              </Col>
              <Col sm={4} md={4} lg={4}>
                <Skeleton width={150} height={40} count={1} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};
export default EnrollmentRulesSkeleton;
